export function getStep({ device, product }) {
  if (!device?.brand) return 0;
  if (!device?.model.id || !device?.model.name) return 1;
  if (!device?.color) return 2;
  if (product?.id) return 3;
  return 2;
}

export default {};
